import PropTypes from "prop-types";
import { CgFileDocument } from "react-icons/cg";

const ClassificationIcon = ({ size, className }) => {
  return (
    <CgFileDocument
      className={`no-shrink  ${className}`}
      size={size}
      title="Classify"
    />
  );
};

ClassificationIcon.defaultProps = {
  size: 30,
  className: "",
};

ClassificationIcon.propTypes = {
  size: PropTypes.number,
  className: PropTypes.string,
};

export default ClassificationIcon;
